import { MutationHookOptions } from '@apollo/client'
import { useCallback } from 'react'

import { FeedbackPostCommentsDocument, useCreateFeedbackPostCommentMutation } from '~generated/hooks'
import {
  CreateFeedbackPostCommentMutation,
  CreateFeedbackPostCommentMutationVariables,
  FeedbackPostCommentsQuery,
} from '~generated/operations'
import { CreateFeedbackCommentInput } from '~generated/types'

function useCreateFeedbackPostComment(
  baseOptions?: MutationHookOptions<CreateFeedbackPostCommentMutation, CreateFeedbackPostCommentMutationVariables>
) {
  const [createFeedbackCommentMutation, options] = useCreateFeedbackPostCommentMutation(baseOptions)

  const createFeedbackComment = useCallback(
    (input: CreateFeedbackCommentInput) => {
      createFeedbackCommentMutation({
        variables: {
          input,
        },
        update: (cache, result) => {
          if (result.data) {
            cache.updateQuery<FeedbackPostCommentsQuery>(
              {
                query: FeedbackPostCommentsDocument,
                variables: {
                  id: input.postId,
                },
              },
              (query) => {
                if (!query) {
                  return {
                    __typename: 'Query',
                    feedbackPost: {
                      __typename: 'FeedbackPostDto',
                      id: input.postId,
                      comments: [result.data.createFeedbackCommentAsAdmin],
                    },
                  } as FeedbackPostCommentsQuery
                }

                return {
                  ...query,
                  feedbackPost: {
                    ...query.feedbackPost,
                    comments: [...(query.feedbackPost.comments ?? []), result.data.createFeedbackCommentAsAdmin],
                  },
                }
              }
            )
          }
        },
      })
    },
    [createFeedbackCommentMutation]
  )

  return [createFeedbackComment, options] as const
}

export default useCreateFeedbackPostComment
